import React from "react";

const CheckboxCheck = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
        <polygon
            transform="translate(2, 3)"
            points="6.5438465 0.09090909 7.6363636 1.18342622 3.03434216 5.7854477 0.36363636 3.11474189 1.45615349 2.02222476 3.03434216 3.60041344"
            fill="currentColor"
        />
    </svg>
);

export default CheckboxCheck;
